import { render, staticRenderFns } from "./project_internal.vue?vue&type=template&id=4859b637&"
import script from "./project_internal.vue?vue&type=script&lang=js&"
export * from "./project_internal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports